import "./selector.css";
import { Selector } from './selector';
export default Selector;